import React, { useContext, useState } from 'react';
import { Timeout, formattedDate } from '../../functions/functions';
import { FormDataScientificDayContext, ShowScientificDayContext } from './types';
import ButtonsForm from '../../HtmlComponents/ButtonsForm';
import InputsScientificDay from './forms/InputsScientificDay';
import { useDispatch } from 'react-redux';
import { AddScientificDayApi } from '../../redux/scientificday/scientificDayApiCalls';
import ShowErrorMsg from '../../HtmlComponents/ShowErrorMsg';

interface props {
  modal: boolean, 
  toggle: any
}

const AddScientificDayModal: React.FC<props> = ({ modal, toggle }) => {
  const [theme, setTheme] = useState("")
  const [RegFees, setRegFees] = useState("")
  const [createdAt, setCreatedAt] = useState<string>(formattedDate(new Date().toString()))

  const [loading, setLoading] = useState(false)
  const [images, setImages] = useState<File[] | any>(null)
  
  
  const dispatch: any = useDispatch()

  const [errors, setErrors] = useState<string[]>([])

  const { setShowSuccessMsg } = useContext(ShowScientificDayContext)

  const handleSubmit = async (e: any) => {
    e.preventDefault()
    setLoading(true)
    try {
      const formData: any = new FormData()
      formData.append("theme", theme)
      formData.append("RegFees", RegFees)
      formData.append("createdAt", createdAt)

      if(images) {
        for (let i = 0; i < images.length; i++) {
          formData.append("images", images[i]);
        }
      }
  
      const response: any = await dispatch(AddScientificDayApi(formData))
      if(response === true) {
        toggle()
        setShowSuccessMsg(true)
        setTimeout(() => setShowSuccessMsg(false), Timeout)
        setTheme("")
        setRegFees("")
        setImages([])
        setCreatedAt(formattedDate(new Date().toString()))
      } else {
        setErrors(response)
      }
    } finally {
      setLoading(false)
    }
  }

  return (
    <FormDataScientificDayContext.Provider value={{
      theme, setTheme,
      RegFees, setRegFees,
      createdAt, setCreatedAt,
      images, setImages
    }}>
    {modal && (
        <>
          <div className="fixed inset-0 z-10 overflow-y-auto">
            <div
              className="fixed inset-0 w-full h-full bg-black opacity-40"
              onClick={toggle}
            ></div>
            <div className="flex items-center min-h-screen px-4 py-8">
              <div className="relative w-full max-w-lg p-4 mx-auto bg-white rounded-md shadow-lg">
                <div className="mt-3">
                  {/* Start Modal Body */}
                  <form
                    className="mt-2 sm:ml-4 sm:text-left"
                    onSubmit={handleSubmit}
                    encType="multipart/form-data"                  
                  >
                    <ShowErrorMsg errors={errors} setErrors={setErrors} />
                    <InputsScientificDay />
                    <ButtonsForm loading={loading} typeBtn='Ajouter' toggle={toggle} />
                  </form>
                  {/* End Modal Body */}
                </div>
              </div>
            </div>
          </div>
        </>
      )}
    </FormDataScientificDayContext.Provider>
  );
}

export default AddScientificDayModal
